import { Dialog } from '@headlessui/react';
import { COMMON_TRANSLATE_KEYS } from '../../constants/translate-keys';
import { useTranslation } from 'react-i18next';
import Button from '../buttons/Button';
import Divider from '../ui/Divider';

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  title: string;
  onConfirm: () => Promise<void>;
  onDecline: () => void;
  additionalText?: string;
};

const AreYouSureModal = ({
  closeModal,
  isOpen,
  onConfirm,
  onDecline,
  title,
  additionalText,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      className="fixed inset-0 flex items-center justify-center z-[50]"
    >
      <Dialog.Overlay className="fixed inset-0 bg-black  opacity-50" />
      <div className="bg-gray-900 lg:w-[40%] w-[60%] p-6 rounded-md absolute top-212 left-468">
        <Dialog.Title>
          <div className="flex flex-col">
            <div className="flex w-full justify-end text-mainWhite">
              <button onClick={closeModal}>X</button>
            </div>
            <h1 className="flex flex-row justify-start text-white text-xl font-bold mb-6 text-start">
              {title}
            </h1>
          </div>
        </Dialog.Title>

        <div className="flex flex-col gap-5 w-full">
          {additionalText && (
            <>
              <Divider />
              <p className="text-textGray text-base">{additionalText}</p>
              <Divider />
            </>
          )}
          <div className="flex flex-row gap-8 justify-around">
            <Button
              onClick={async () => await onConfirm()}
              type="button"
              backgroundColor="bg-cancel"
              textColor="text-white"
              width={16}
              height={3}
            >
              {t(COMMON_TRANSLATE_KEYS.YES)}
            </Button>
            <Button
              onClick={() => onDecline()}
              type="button"
              backgroundColor="bg-transparent"
              border="border"
              borderColor="border-mainBlue"
              textColor="text-mainBlue"
              width={16}
              height={3}
            >
              {t(COMMON_TRANSLATE_KEYS.NO)}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AreYouSureModal;
